<template>
  <div class="admin-general">
    <div>
      <table class="admin-table">
        <thead>
          <tr>
            <th>{{ $tr('admin_console.company.general.createdAt') }}</th>
            <th>{{ $tr('admin_console.company.general.limit') }}</th>
            <!-- <th>{{ $tr('admin_console.company.general.specialProcess') }}</th>
            <th>{{ $tr('admin_console.company.general.specialProcessDescr') }}</th> -->
            <th>{{ $tr('admin_console.company.general.vacancy') }}</th>
            <th>{{ $tr('admin_console.company.general.recruiters') }}</th>
            <th>{{ $tr('admin_console.company.general.responses') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{created_at}}</td>
            <td>
              <div v-if="is_rates_started || is_unlimited">{{ $tr('admin_console.company.general.dateExpire') }} {{limit_paid_to}}</div>
              <div v-else>{{$tr('admin_console.company.general.dateStart')}} {{limit_paid_from}}</div>
              <div>{{ $tr('admin_console.company.general.leftResponses') }}: {{limit_response_balance}}</div>
              <div><button class="vcv-button transparent link" @click="go_to_rates">{{ $tr('admin_console.company.general.change') }}</button></div>
            </td>
            <!-- <td>{{active_process ? 'Да' : 'Нет'}}</td>
            <td>{{active_process || '-'}}</td> -->
            <td>
              <div>{{ $tr('admin_console.company.general.active') }} {{vacancy_active}}</div>
              <div>{{ $tr('admin_console.company.general.notActive') }} {{vacancy_inactive}}</div>
              <div>{{ $tr('admin_console.company.general.archive') }} {{vacancy_archived}}</div>
              <div>{{ $tr('admin_console.company.general.total') }} {{vacancy_all}}</div>
            </td>
            <td>
              <div>{{ $tr('admin_console.company.general.active') }} {{user_active}}</div>
              <div>{{ $tr('admin_console.company.general.notActive') }} {{user_inactive}}</div>
              <div>{{ $tr('admin_console.company.general.total') }} {{user_all}}</div>
            </td>
            <td>{{ $tr('admin_console.company.general.total') }} {{response_all}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="token-block">
      <vbutton v-if="!apiToken"
        text="Сгенерировать токен"
        :disabled="tokenLoading"
        :loading="tokenLoading"
        @click="generateToken"/>
      <div v-else>
        <div>Токен:</div>
        <trigger
                class="status-switch"
                :disabled="tokenLoading"
                v-model="is_token_active"
        />
        <div class="token-input">
          {{apiToken}}
        </div>
        <div>
          Предоставляя токен клиенту не забудьте передать документацию. <a href="https://vcv-files.s3-eu-west-1.amazonaws.com/docs/API.docx" target="_blank" rel="noopener">Скачать</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { STORE_PREFIX } from '../constants.js';
  import { mapGetters } from 'vuex';
  import Trigger from '@/components/shared/MinimalisticTrigger.vue'

  import moment from 'moment'

  export default {
    name: 'admin-general-scene',

    props: {
      companyId: null
    },

    components: {
      Trigger
    },

    data() {
      return {
        generatedToken: null,
        tokenLoading: false,
        is_token_enabled: null
      }
    },

    computed: {
      ...mapGetters(STORE_PREFIX + 'admin', {
        company: 'company/one'
      }),

      is_token_active: {
        get() {
          if (this.is_token_enabled === null) {
            return this.company ? this.company.is_api_token_active : false;
          }

          return this.is_token_enabled;
        },

        set(val) {
          this.is_token_enabled = val;
          this.tokenLoading = true;
          axios.put(`/1.0/admin/companies/${this.companyId}/token`, {is_active: val})
                  .then(response => {
                    this.tokenLoading = false;
                  })
                  .catch(e => {
                    this.tokenLoading = false;
                    this.$noty.error(this.$tr('common.error.networkError'));
                  });
        }
      },

      apiToken() {
        if (this.company && this.company.api_token) {
          return this.company.api_token;
        }
        return this.generatedToken;
      },

      created_at () {
        if (!this.company) {
          return '';
        }
        const date = new Date(this.company.created_at)

        return moment(date).format('DD-MM-YYYY')
      },

      limit_paid_from () {
        if (!this.company || !this.company.limits) {
          return '';
        }

        const limit_paid_from = this.company.limits.paid_from

        if (limit_paid_from === null) {
          return limit_paid_from
        }

        return moment(limit_paid_from).format('DD-MM-YYYY')
      },

      is_rates_started() {
        if (!this.company || !this.company.limits || !this.company.limits.paid_from) {
          return true
        }

        const paid_from = this.company.limits.paid_from;

        return moment(paid_from).startOf('day').diff(moment().startOf('day'), 'days') <= 0;
      },

      is_unlimited() {
        if (!this.company || !this.company.limits) {
          return false;
        }

        return this.company.limits.paid_to === null;
      },

      limit_paid_to () {
        if (!this.company || !this.company.limits) {
          return '';
        }

        const limit_paid_to = this.company.limits.paid_to

        if (limit_paid_to === null) {
          return this.$tr('admin_console.company.general.noLimit');
        }

        return moment(limit_paid_to).format('DD-MM-YYYY')
      },

      limit_response_balance () {
        if (!this.company || !this.company.limits) {
          return '';
        }

        const balance = this.company.limits.response_balance;

        if (balance === null) {
          return this.$tr('admin_console.company.general.noLimit');
        }

        return balance;
      },

      vacancy_active () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.company.counts.vacancy_active
      },

      vacancy_all () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.company.counts.vacancy_all
      },

      vacancy_inactive () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.vacancy_all - this.vacancy_active
      },

      vacancy_archived () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.company.counts.vacancy_archive
      },

      user_active () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.company.counts.user_active
      },

      user_all () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.company.counts.user_all
      },

      user_inactive () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.user_all - this.user_active
      },

      response_all () {
        if (!this.company || !this.company.counts) {
          return 0
        }

        return this.company.counts.response
      },

      active_process () {
        if (!this.company || !this.company.meta) {
          return '';
        }

        return this.company.meta.active_process;
      }
    },

    methods: {
      go_to_rates() {
        this.$router.push({
          name: 'admin-company-rates',
          params: { companyId: this.companyId }
        })
      },

      fetch_company() {
        this.$store.dispatch(STORE_PREFIX + 'admin/company/fetch', this.companyId)
      },

      fetch_rates() {
        this.$store.dispatch(STORE_PREFIX + 'admin/rates/get_company_rates', {
          id: this.companyId
        })
      },

      generateToken() {
        this.tokenLoading = true;
        axios.post(`/1.0/admin/companies/${this.companyId}/token`)
          .then(response => {
            this.tokenLoading = false;
            if (response && response.data && response.data.data && response.data.data[0]) {
              this.generatedToken = response.data.data[0].api_token;
              this.is_token_enabled = response.data.data[0].is_api_token_active;
            }
          })
          .catch(e => {
            this.tokenLoading = false;
            this.$noty.error(this.$tr('common.error.networkError'));
          });
      }
    },

    beforeMount () {
      this.fetch_company()
      this.fetch_rates()
    },

    beforeDestroy() {
      this.$store.commit(STORE_PREFIX + 'admin/company/clear')
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.token-block {
  margin-top: 50px;

  a {
    color: $green;
  }
}

.token-input {
  margin-bottom: 10px;
  margin-top: 4px;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-width: 600px;
  padding: 8px;
  font-size: 16px;
  display: inline-block;
}
</style>
